'use es6';

import { Record } from 'immutable';
export default Record({
  timeRange: null,
  entityId: null,
  entityType: null,
  network: null,
  attributionView: null,
  statuses: null
});